<template>
  <a-row :gutter="8" :class="getScreen ? 'm-list-wrapper' : 'd-list-wrapper'">
    <a-col :xs="{ span: 24 }" :lg="{ span: 8 }">
      <a-card :loading="loading">
        <div slot="title">
          <a-icon type="file-search" class="margin-right-small" />Search
        </div>
        <ul class="m-list-wrapper">
          <li>
            <a-input-search v-model="search" placeholder="Quick Search" />
          </li>
          <li>
            <a-collapse activeKey="1">
              <a-collapse-panel key="1">
                <span slot="header">Search More...</span>
                <div class="m-form-item-wrapper">
                  <label for="tanggalTransaksi">Budget Type</label>
                  <a-select
                    placeholder="Ex: choose ... "
                    v-model="jenisAnggaran"
                    @change="searching"
                    class="width-full"
                    allowClear
                  >
                    <a-select-option
                      v-for="item in s_jnsAnggrn"
                      :key="item"
                      :value="item"
                      >{{ item }}</a-select-option
                    >
                  </a-select>
                </div>
                <div class="m-form-item-wrapper">
                  <label for="tanggalTransaksi">Year</label>
                  <a-select
                    placeholder="Ex: 2021 ... "
                    v-model="thnbgt"
                    @change="searching"
                    class="width-full"
                    allowClear
                  >
                    <a-select-option
                      v-for="item in s_thnbudget"
                      :key="item"
                      :value="item"
                      >{{ item }}</a-select-option
                    >
                  </a-select>
                </div>
                <div class="m-form-item-wrapper">
                  <label for="sts">Status</label>
                  <a-select
                    v-model="sts"
                    @change="searching"
                    class="width-full"
                    allowClear
                  >
                    <a-select-option value="0">Open</a-select-option>
                    <a-select-option value="1">Close</a-select-option>
                  </a-select>
                </div>
                <div class="m-form-item-wrapper">
                  <label for="sts">Site</label>
                  <a-select
                    v-model="site"
                    @change="searching"
                    class="width-full"
                    allowClear
                  >
                    <a-select-option v-for="item in l_site" :key="item.site">
                      {{item.site}}</a-select-option>
                  </a-select>
                </div>
              </a-collapse-panel>
            </a-collapse>
          </li>
        </ul>
      </a-card>
      <a-collapse activeKey="1" class="margin-top">
        <a-collapse-panel key="1" >
          <span slot="header">Download Template</span>
          <a-card :loading="loading">
            <div class="m-form-item-wrapper">
              <label for="sts">Budget Template</label>
              <a-select
                v-model="template.url"
                class="width-full"
                placeholder="Choose Template ... "
                allowClear
                showSearch
                :filter-option="filterOption"
              >
                <a-select-option v-for="(item, index) in template.list" :key="index" :value="item.url">
                  {{item.label}}</a-select-option>
              </a-select>
              <a-button type="primary" class="width-full margin-top" @click="handleDownloadTemplate">
                  <a-icon type="download" />&nbsp;Download
              </a-button>
            </div>
          </a-card>
        </a-collapse-panel>
      </a-collapse>
    </a-col>
    <a-col :xs="{ span: 24 }" :lg="{ span: 16 }">
      <DataList
        :loading="loading"
        title="Budget"
        createLink="anggaranCreate"
        :manifestLink="toManifest"
        editLink="anggaranEditAcc"
        :disabledCreateEditLink="true"
        :tabbedBudget="true"
        :dataList="dataListOutput"
        :rating="false"
      />
    </a-col>
  </a-row>
</template>

<script>
import { mapGetters } from "vuex";
import Axios from "axios";
import moment from "moment";
import Status from "@/components/Status.vue";
import _ from "lodash";

export default {
  name: "Anggaran",
  components: {
    Status,
  },
  data() {
    return {
      loading: true,
      anggaranList: [],
      draftList: [],
      storeList: [],
      search: "",
      searchDate: null,
      status: undefined,
      jenisAnggaran: "",
      s_jnsAnggrn: [],
      s_thnbudget: [],
      thnbgt: "",
      pagination: {
        pageSize: 5,
        size: 'small',
      },
      sts: undefined,
      l_site:[],
      site:"",
      template :{
        url:undefined,
        list:[],
      }
    };
  },
  computed: {
    ...mapGetters([
      "getScreen",
      "getAuth",
      "getSalesType",
      "getStatus",
      "getDefaultDateFormat",
    ]),
    dataListOutput() {
      let output = [];

      this.anggaranList.forEach((data) => {
        output.push({
          title: data.cost_center_kode,
          subtitle: data.cost_center_nm ? data.cost_center_nm : "-",
          subdesc: [
            {
              label: "Year / Rev.num. :",
              value:
                (data.budget_thn ? data.budget_thn : "") +
                " / " +
                (data.revisi_no ? data.revisi_no : ""),
            },
            {
              label: "Budget Type :",
              value: data.nm_anggaran,
            },
            {
              label: "Site :",
              value: data.site,
            },
            {
              label: "Description :",
              value: data.pekerjaan_nm,
            },
          ],
          timeline: JSON.parse(data.status_app),
          status: data.status,
          close_budget: data.sts_close == "1" ? "Close" : "Open",
          budget_thn: data.budget_thn,
          id: data.anggaran_id,
        });
      });

      return output;
    },
    draftListOutput() {
      let output = [];

      this.anggaranList.forEach((data) => {
        output.push({
          title: data.cost_center_kode,
          subdesc: [
            {
              label: "Year / Rev.num. :",
              value:
                (data.budget_thn ? data.budget_thn : "") +
                " / " +
                (data.revisi_no ? data.revisi_no : ""),
            },
            {
              label: "Budget Type :",
              value: data.nm_anggaran,
            },
          ],
          timeline: JSON.parse(data.status_app),
          status: data.status,
          id: data.id_lk_draft,
          price: data.grand_total,
          mata_uang: data.currency,
        });
      });

      return output;
    },
    searching() {
      let filteredDataBySearch = [];
      this.anggaranList = this.storeList;

      if (this.search) {
        this.anggaranList = this.anggaranList.filter(
          (obj) =>
            (obj.cost_center_kode ? obj.cost_center_kode : " ")
              .toLowerCase()
              .indexOf(this.search.toLowerCase()) >= 0 ||
            (obj.cost_center_nm ? obj.cost_center_nm : " ")
              .toLowerCase()
              .indexOf(this.search.toLowerCase()) >= 0 ||
            (obj.budget_thn ? obj.budget_thn : " ")
              .toLowerCase()
              .indexOf(this.search.toLowerCase()) >= 0 ||
            (obj.revisi_no ? obj.revisi_no : " ")
              .toLowerCase()
              .indexOf(this.search.toLowerCase()) >= 0 ||
            (obj.nm_anggaran ? obj.nm_anggaran : " ")
              .toLowerCase()
              .indexOf(this.search.toLowerCase()) >= 0
        );
      }

      if (this.jenisAnggaran) {
        this.anggaranList = this.anggaranList.filter(
          (obj) =>
            obj.nm_anggaran &&
            ("(" + obj.jns_anggaran_id + ") " + obj.nm_anggaran)
              .toLowerCase()
              .indexOf(this.jenisAnggaran.toLowerCase()) >= 0
        );
      }

      if (this.thnbgt) {
        this.anggaranList = this.anggaranList.filter(
          (obj) =>
            obj.budget_thn &&
            obj.budget_thn.toLowerCase().indexOf(this.thnbgt.toLowerCase()) >= 0
        );
      }

      if (this.sts) {
        this.anggaranList = this.anggaranList.filter(
          (obj) =>
            obj.sts_close &&
            obj.sts_close.toLowerCase().indexOf(this.sts.toLowerCase()) >= 0
        );
      }

      if (this.site) {
        this.anggaranList = this.anggaranList.filter(
          (obj) =>
            obj.site &&
            obj.site.toLowerCase().indexOf(this.site.toLowerCase()) >= 0
        );
      }

      if (!this.jenisAnggaran && !this.search && !this.thnbgt && !this.sts && !this.site) {
        this.anggaranList = this.storeList;
      }
    },
    bidangAccountManager() {
      let returnVal = true;
      this.getAuth.nama_bidang.forEach((data) => {
        if (data === "Account Manager") {
          returnVal = false;
          return;
        }
      });
      return returnVal;
    },
    toManifest(){
      return "budget-manifest";
      
      // if(this.$route.path.includes("/financialControl")){
      //   return "anggaran.manifestFin"
      // }else{
      //   return "anggaran.manifestAcc"
      // }
    }
  },
  methods: {
    moment,
    fetchData() {
      Axios({
        method: "get",
        url: this.$serviceUrl + "anggaran",
        params: {
          tlc: this.getAuth.username,
          id_menu: localStorage.getItem('nvky')
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      })
        .then((response) => {
          let tempAnggaran = response.data.data;
          this.anggaranList = tempAnggaran;
          this.storeList = response.data.data;
          this.l_site = response.data.list_site;
          this.loading = false;

          tempAnggaran = _.filter(tempAnggaran, item=>{ return !item.jns_anggaran_id.includes("x")})
          this.s_jnsAnggrn = _.uniq(
            _.map(
              _.sortBy(tempAnggaran, (o) => o.jns_anggaran_id, "asc"),
              function join(n) {
                return "(" + n.jns_anggaran_id + ") " + n.nm_anggaran;
              }
            )
          );
          this.s_thnbudget = _.uniq(_.map(this.anggaranList, "budget_thn"));
          this.getListTemplate();
        })
        .catch((err) => {
          if (!err.response) {
            this.displayMessage("error-connection-refused");
          } else {
            this.loading = false;
            this.displayMessage("empty-db");
          }
        });
    },
    async getListTemplate(){
      await Axios({
        method: "get",
        url: this.$serviceUrl + "anggaran/template",
        params: {
          tlc: this.getAuth.username,
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      })
      .then((response) => {
        this.template.list = response.data.list_template;
      })
      .catch((err) => {
          console.log(err)
      });
    },
    handleDownloadTemplate(){
      if (!this.template.url){
        this.displayMessageValue("error-other", "Template is empty!");
      }else{
        window.open(this.$serviceUrl + this.template.url, "_blank");
      }
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      );
    },
  },
  mounted() {
    this.fetchData();
  },
};
</script>

<style></style>
